<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">使用画像指示</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-row">
          <div class="column-list" style="width:170px;">
            <label class="list-input-title">Pコード</label>
            <div class="list-input-content">
              <input type="text" class="pcode" value="{{kymw1407Model.pcode}}" readonly>
            </div>
            <label class="list-input-title">商品件数</label>
            <div class="list-input-content">
              <input type="text" style="width:7rem;" value="{{kymw1407Model.otherGoodsCount}}" readonly>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">商品名</label>
            <div class="list-input-content">
              <input type="text" class="guide-goods-name" value="{{kymw1407Model.guideGoodsName}}" readonly>
            </div>
            <label class="list-input-title">規格名</label>
            <div class="list-input-content">
              <input type="text" class="guide-standard-name" value="{{kymw1407Model.guideStandardName}}" readonly>
            </div>
          </div>
        </div>

        <div>
          <h2>使用画像</h2>
          <app-kymw1407-use-image id="vw_UseImage" #vw_UseImage forcedEnabledMode="'true'"
            [useImageList]="kymw1407Model.useImageList"
            (eventUseImageList_ITEMCLICK)="eventUseImageList_ITEMCLICKHandler($event)"></app-kymw1407-use-image>
        </div>

        <div>
          <h2>検索結果</h2>
          <app-kymw1407-search-result id="vw_SearchResult" #vw_SearchResult
            (eventPcodeList_CHANGE)="eventPcodeList_CHANGEHandler($event)"
            (eventPcodeInfoList_CLICK)="eventPcodeInfoList_CLICKHandler($event)"
            (eventGoodsImageList_ITEMCLICK)="eventGoodsImageList_ITEMCLICKHandler($event)"
            (eventUseHistoryImageList_ITEMCLICK)="eventUseHistoryImageList_ITEMCLICKHandler($event)"
            (eventSearchImageList_ITEMCLICK)="eventSearchImageList_ITEMCLICKHandler($event)"
            (eventBtnSearch_CLICK)="eventBtnSearch_CLICKHandler()" forcedEnabledMode="true"
            [goodsImageList]="kymw1407Model.goodsImageList" [pcodeList]="kymw1407Model.pcodeList"
            [pcodeInfoList]="kymw1407Model.pcodeInfoList" [useHistoryImageList]="kymw1407Model.useHistoryImageList"
            [searchImageList]="kymw1407Model.searchImageList">
          </app-kymw1407-search-result>
        </div>

        <div>
          <h2>画像情報詳細</h2>
          <app-kymw1407-image-info-detail id="vw_ImageInfoDetail" #vw_ImageInfoDetail forcedEnabledMode="true"
            [goodsImagePreviewURL]="kymw1407Model.goodsImagePreviewURL"
            (eventImageInfoDetailCHANGE)="eventImageInfoDetailCHANGEHandler($event)"
            (changeStartOrderCode)="eventImageInfoDetailStartOrderCodeCHANGEHandler($event)"
            (changeEndOrderCode1)="eventImageInfoDetailEndOrderCodeCHANGEHandler($event)"
            (changeEndOrderCode2)="bindEndOrderCodeComboBox($event.index)"
            (eventSettingCLICK)="eventSetting_CLICKHandler()" (eventResetCLICK)="eventReset_CLICKHandler()"
            (eventUseStopCLICK)="eventUseStop_CLICKHandler()">
          </app-kymw1407-image-info-detail>
        </div>
      </div>
      <div class="window-title-close">
        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <button [tabindex]="0" (click)="eventBtnClose_CLICKHandler()"></button>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>